import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useSelector } from 'react-redux'
import persistState from 'redux-localstorage'

import user from './user'
import college from './college'
import messaging from './messaging'
import features from './feature-toggle'
import visitSelectedSchools from './selected-schools'
import linkedCalendars from './linked-calendars'
import calendarUpcomingVisits from './upcoming-visits'
import snackbar from './snackbar'
import savedSearch from './saved-search'
import mapFilters from './map-filters'
import calendarVisitTypeFilters from './calendar-visit-type-filter'
import applicationCycle from './application-cycle'

const rootReducer = combineReducers({
  user,
  applicationCycle,
  college,
  messaging,
  features,
  savedSearch,
  visitSelectedSchools,
  linkedCalendars,
  calendarUpcomingVisits,
  snackbar,
  mapFilters,
  calendarVisitTypeFilters,
})
const store = configureStore({
  reducer: rootReducer,
  enhancers: [
    persistState<RootState>(
      ['visitSelectedSchools', 'linkedCalendars', 'savedSearch', 'mapFilters', 'calendarVisitTypeFilters'],
      {
        key: 'scoir-admissions-redux-state',
      },
    ),
  ],
})

export type RootState = ReturnType<typeof rootReducer>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
